import * as Yup from "yup";

export default Yup.object().shape({
  name: Yup.string().required("Field is required"),
  unit: Yup.string().required("Field is required"),
  category: Yup.string().required("Field is required"),
});
